module.exports = __webpack_public_path__ + "img/score_bg2.2322109.png";